import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/site";
import { Reveal, RevealImage, SectionMark } from "./Reveal";

export const ServicesEditorial = () => (
    <section
        id="usluge"
        data-testid="services-section"
        className="relative px-5 py-24 md:px-10 md:py-40"
    >
        <div className="mx-auto max-w-[1400px]">
            <Reveal>
                <SectionMark>( 04 — Što radimo )</SectionMark>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-6 pb-1 font-display text-[9vw] font-light leading-[1.06] tracking-tight text-bone md:text-[4vw]">
                    USLUGE
                </h2>
            </Reveal>

            <div className="mt-10 md:mt-20">
                {SERVICES.map((s, i) => {
                    const flip = i % 2 === 1;
                    return (
                        <div
                            key={s.num}
                            data-testid={`service-${s.num}`}
                            className="grid items-center gap-8 border-t border-white/[0.07] py-14 md:grid-cols-12 md:gap-12 md:py-24"
                        >
                            <div
                                className={`md:col-span-4 ${
                                    flip ? "md:order-2 md:pl-10" : ""
                                }`}
                            >
                                <Reveal>
                                    <span className="font-display text-6xl font-light text-bronze/60 md:text-8xl">
                                        {s.num}
                                    </span>
                                </Reveal>
                                <Reveal delay={0.08}>
                                    <h3 className="mt-4 font-display text-2xl font-light tracking-wide text-bone md:text-4xl">
                                        {s.title}
                                    </h3>
                                </Reveal>
                                <Reveal delay={0.16}>
                                    <p className="mt-5 max-w-xs text-sm leading-relaxed text-silver">
                                        {s.desc}
                                    </p>
                                </Reveal>
                                <Reveal delay={0.22}>
                                    <Link
                                        to="/termin"
                                        data-testid={`service-cta-${s.num}`}
                                        className="mt-7 inline-flex items-center gap-2 border-b border-bone/25 pb-1 text-[11px] font-medium uppercase tracking-[0.26em] text-bone/80 transition-colors duration-300 hover:border-bronze hover:text-bronze"
                                    >
                                        Zakaži termin
                                        <ArrowUpRight size={14} strokeWidth={1.5} />
                                    </Link>
                                </Reveal>
                            </div>
                            <div
                                className={`md:col-span-8 ${
                                    flip ? "md:order-1" : ""
                                }`}
                            >
                                <RevealImage
                                    src={s.image}
                                    alt={s.alt}
                                    className="aspect-[4/3] md:aspect-[16/10]"
                                    delay={0.1}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    </section>
);
